import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  // page: {
  //   padding: 5,
  //   fontSize: 9,
  //   flexDirection: "column",
  // },
    page: {
    paddingTop: 80,       // ✅ reserve header space
    paddingBottom: 40,    // ✅ reserve footer space
    paddingHorizontal: 10,
    fontSize: 9,
  },
//   page: {
//   paddingTop: 80,
//   paddingBottom: 100, // ✅ MUST BE >= footer height
//   paddingHorizontal: 10,
//   fontSize: 9,
// },

  title: {
    textAlign: "center",
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 15,
  },

  overheadTitle: {
    fontSize: 11,
    fontWeight: "bold",
    marginBottom: 6,
  },

  projectName: {
    fontSize: 10,
    // fontWeight: "bold",
    marginBottom: 4,
  },

  table: {
    display: "table",
    width: "100%",
    marginBottom: 8,
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
  },

  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
  },
    tableRowBottom: {
    flexDirection: "row",
    // borderBottomWidth: 1,
    borderColor: "#000",
  },

  headerCell: {
    padding: 4,
    fontWeight: "bold",
    backgroundColor: "#f0f0f0",
    borderRightWidth: 1,
    borderColor: "#000",
    textAlign: "center",
  },

  cell: {
    padding: 4,
    borderRightWidth: 1,
    borderColor: "#000",
  },

  rightCell: {
    padding: 4,
    textAlign: "right",
  },

  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 8,
    fontSize: 10,
    fontWeight: "bold",
  },
  separator: {
    width: "100%",
    height: 1,
    backgroundColor: "#000",
    marginTop: 12,
    marginBottom: 12,
  },
  separator2: {
    width: 1,
    backgroundColor: "#000",
    marginHorizontal: 8,
  },
  /*Header*/
  headerWrapper: {
    position: "absolute",
    top: 15,
    left: 20,
    right: 20,
    height: 50,
    justifyContent: "center",
    alignItems: "center",
  },
  headerImage: {
    width: "100%",
    height: 50,
    objectFit: "contain",
  },
  /* FOOTER */

  footerWrapper: {
    position: "absolute",
    bottom: 25,
    left: 5,
    right: 5,
    height: 75,
    justifyContent: "center",
    alignItems: "center",
  },
  footerImage: {
    width: "100%",
    height: 100,
    objectFit: "cover",
  },
//   footerWrapper: {
//   position: "absolute",
//   bottom: 10,
//   left: 10,
//   right: 10,
//   height: 60, // ✅ FIXED
  
// },

// footerImage: {
//   width: "100%",
//   height: 60, // ✅ SAME
//   objectFit: "contain", // ✅ no overflow
// },
  section: {
    marginBottom: 5,
    marginTop: 80,
  },
});

// GROUP BY OVERHEAD FIRST
const groupByOverhead = (data) => {
  const result = {};
  data.forEach((row) => {
    if (!result[row.Overheads]) {
      result[row.Overheads] = [];
    }
    result[row.Overheads].push(row);
  });
  return result;
};

// THEN GROUP A SINGLE OVERHEAD BY PRODUCT
const groupByProduct = (rows) => {
  const result = {};
  rows.forEach((r) => {
    if (!result[r.ProjectName]) result[r.ProjectName] = [];
    result[r.ProjectName].push(r);
  });
  return result;
};

const OHsummaryPDF = ({ data = [], filters = {} }) => {
  const overheadGroups = groupByOverhead(data);
  let grandProductTotal = 0;
  let finalGrandTotal = 0;
  let finalCreditTotal = 0;
  let finalDebitTotal = 0;
  const formatAmount = (value) =>
    Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View fixed style={styles.headerWrapper}>
                    {filters.HeaderImg && (
                        <Image
                            src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
                            style={styles.headerImage}
                        />
                    )}
                </View>
        {/* <View style={styles.section}> */}
        <Text style={styles.title}>
          Onsite Activities - Overhead based Summary
        </Text>
        {/* </View> */}
        {Object.entries(overheadGroups).map(
          ([overheadName, ohRows], ohIndex) => {
            // const totalTransactions = ohRows.length;
            // const totalAmount = ohRows.reduce(
            //     (sum, r) => sum + Number(r.Value || 0),
            //     0
            // );
            // grandProductTotal += totalAmount;
            // Group by product inside this overhead
            //  Filter valid rows first
            const validOverheadRows = ohRows.filter(
              (r) => r.ChildYorN === "Y" && Number(r.Quantity || 0) > 0,
            );

            //  Skip entire overhead if no valid rows
            if (validOverheadRows.length === 0) {
              return null;
            }
            // if (validOverheadRows.length === 0) {
            //     return (
            //         <View>
            //             <Text style={{ fontStyle: "italic", textAlign: "center", marginVertical: 5 }}>
            //                 No Data Available
            //             </Text>
            //         </View>
            //     );
            // }

            const totalTransactions = validOverheadRows.length;

            const totalAmount = validOverheadRows.reduce(
              (sum, r) => sum + Number(r.Value || 0),
              0,
            );

            // grandProductTotal += totalAmount;

            // Group using only valid rows
            const productGroups = groupByProduct(validOverheadRows);
            const allFilteredRows = Object.values(productGroups)
              .flat()
              .filter(
                (r) => r.ChildYorN === "Y" && Number(r.Quantity || 0) > 0,
              );

            const totalCreditAmount = allFilteredRows
              .filter((r) => r.AccountType === "Credit")
              .reduce((sum, r) => sum + Number(r.Value || 0), 0);

            const totalDebitAmount = allFilteredRows
              .filter((r) => r.AccountType === "Debit")
              .reduce((sum, r) => sum + Number(r.Value || 0), 0);
            // const productGroups = groupByProduct(ohRows);
            finalGrandTotal += totalAmount;
            finalCreditTotal += totalCreditAmount;
            finalDebitTotal += totalDebitAmount;
            return (
              <View key={ohIndex} style={{ marginBottom: 10 }}>
                {/* Overhead Name */}
                <Text style={styles.overheadTitle}>
                  Overhead Name : {overheadName}
                </Text>

                {/* EACH PRODUCT TABLE */}
                {Object.entries(productGroups).map(
                  ([productName, productRows], pIndex) => {
                    // const productTotal = productRows.reduce(
                    const validProductRows = productRows.filter(
                      (r) => r.ChildYorN === "Y" && Number(r.Quantity || 0) > 0,
                    );

                    if (validProductRows.length === 0) {
                      return null;
                    }

                    const productTotal = validProductRows.reduce(
                      (sum, r) => sum + Number(r.Value || 0),
                      0,
                    );
                    const productCreditTotal = validProductRows
                      .filter((r) => r.AccountType === "Credit")
                      .reduce((sum, r) => sum + Number(r.Value || 0), 0);

                    const productDebitTotal = validProductRows
                      .filter((r) => r.AccountType === "Debit")
                      .reduce((sum, r) => sum + Number(r.Value || 0), 0);

                    return (
                      <View key={pIndex} style={{ marginBottom: 20 }}>
                        <Text style={styles.projectName}>
                          Project Name : {productName}
                        </Text>

                        {/* Table */}
                        <View wrap={false}>
                        <View style={styles.table}>
                          <View style={styles.tableRow}>
                            <Text style={[styles.headerCell, { flex: 0.5 }]}>
                              SL#
                            </Text>
                            <Text style={[styles.headerCell, { flex: 1 }]}>
                              Date
                            </Text>
                            <Text style={[styles.headerCell, { flex: 5.5 }]}>
                              Comments
                            </Text>
                            {/* <Text style={[styles.rightCell, {
                                                            flex: 1.5, fontWeight: "bold", backgroundColor: "#f0f0f0",
                                                            textAlign: "center"
                                                        }]}>Amount</Text> */}
                            <Text
                              style={[
                                styles.headerCell,
                                { flex: 1.5, textAlign: "center" },
                              ]}
                            >
                              Credit
                            </Text>
                            <Text
                              style={[
                                styles.rightCell,
                                {
                                  flex: 1.5,
                                  fontWeight: "bold",
                                  backgroundColor: "#f0f0f0",
                                  textAlign: "center",
                                },
                              ]}
                            >
                              Debit
                            </Text>
                          </View>

                          {/* {productRows.map((row, i) => ( */}
                          {validProductRows.map((row, i) => (
                            <View key={i} style={styles.tableRow} wrap={false}>
                              <Text
                                style={[
                                  styles.cell,
                                  { flex: 0.5, textAlign: "center" },
                                ]}
                              >
                                {i + 1}
                              </Text>
                              <Text
                                style={[
                                  styles.cell,
                                  { flex: 1, textAlign: "center" },
                                ]}
                              >
                                {row.Date}
                              </Text>
                              <Text style={[styles.cell, { flex: 5.5 }]}>
                                {row.Comments}
                              </Text>
                              {/* <Text style={[styles.rightCell, { flex: 1.5 }]}>
                                                                {row.Value}
                                                            </Text> */}
                              {/* Credit Column */}
                              <Text
                                style={[
                                  styles.cell,
                                  { flex: 1.5, textAlign: "right" },
                                ]}
                              >
                                {row.AccountType === "Credit"
                                  ? Number(row.Value || 0).toFixed(2)
                                  : "0.00"}
                              </Text>

                              {/* Debit Column */}
                              <Text style={[styles.rightCell, { flex: 1.5 }]}>
                                {row.AccountType === "Debit"
                                  ? Number(row.Value || 0).toFixed(2)
                                  : "0.00"}
                              </Text>
                            </View>
                          ))}

                          <View style={styles.tableRowBottom}>
                            <Text style={[styles.cell, { flex: 0.5 }]}></Text>
                            <Text style={[styles.cell, { flex: 1 }]}></Text>
                            <Text
                              style={[
                                styles.cell,
                                {
                                  flex: 5.5,
                                  fontWeight: "bold",
                                  textAlign: "right",
                                },
                              ]}
                            >
                              Total
                            </Text>
                            {/* <Text
                                                            style={[
                                                                styles.rightCell,
                                                                { flex: 1.5, fontWeight: "bold" },
                                                            ]}
                                                        >
                                                            {productTotal.toFixed(2)}
                                                        </Text> */}
                            {/* Credit Total */}
                            <Text
                              style={[
                                styles.cell,
                                {
                                  flex: 1.5,
                                  fontWeight: "bold",
                                  textAlign: "right",
                                },
                              ]}
                            >
                              {formatAmount(productCreditTotal)}
                            </Text>

                            {/* Debit Total */}
                            <Text
                              style={[
                                styles.rightCell,
                                { flex: 1.5, fontWeight: "bold" },
                              ]}
                            >
                              {formatAmount(productDebitTotal)}
                            </Text>
                          </View>
                        </View>
                                  </View>
                      </View>
                    );
                  },
                )}

                {/* Overhead Summary */}
                {/* <View style={styles.summaryRow}>
                                    <Text>Overhead Name : {overheadName}</Text>
                                    <Text>Total Transaction : {totalTransactions}</Text>
                                    <Text>Total Amount : {totalAmount}</Text>
                                </View> */}
                <View style={styles.summaryRow}>
                  <Text>Overhead Name : {overheadName}</Text>

                  {/* <View style={styles.separator2} /> */}

                  <Text>
                    Transaction Count : {formatAmount(totalTransactions)}
                  </Text>

                  {/* <View style={styles.separator2} /> */}

                  <Text>Total Amount : {formatAmount(totalAmount)}</Text>
                </View>

                <View style={styles.separator} />
                {/* <View style={{ marginTop: 10 }}>
                                    <Text style={{ fontWeight: "bold" }}>
                                        Grand Total Amount : {grandProductTotal.toFixed(2)}
                                    </Text>
                                </View> */}
                {/* <View style={styles.projectSummary}>
                                    <Text>Grand Total Amount : {grandProductTotal.toFixed(2)}</Text>
                                    <Text>Credit Amount : {totalCreditAmount.toFixed(2)}</Text>
                                    <Text>Debit Amount : {totalDebitAmount.toFixed(2)}</Text>
                                </View> */}
              </View>
            );
          },
        )}
        <View style={{ marginTop: 15 }}>
          <View style={styles.summaryRow}>
            {/* <Text style={{ fontWeight: "bold" }}>
                            Grand Total Amount : {finalGrandTotal.toFixed(2)}
                        </Text> */}
            <Text style={{ fontWeight: "bold" }}>
              Total Credit Amount : {formatAmount(finalCreditTotal)}
            </Text>
            <Text style={{ fontWeight: "bold" }}>
              Total Debit Amount : {formatAmount(finalDebitTotal)}
            </Text>
          </View>
        </View>
        <View style={styles.separator} />

        <View fixed style={styles.footerWrapper}>
                    {filters.FooterImg && (
                        <Image
                            src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
                            style={styles.footerImage}
                        />
                    )}
                </View>
      </Page>
    </Document>
  );
};

export default OHsummaryPDF;
